import { useApi } from "../useApi"
import { entitlex } from "../../api/entitlex"

export const useEntitlexApi = () => useApi(entitlex)
